import { useQuery } from '@tanstack/react-query'
import { searchHotels } from 'tripPlanner/api'
import * as HotelSearchKeys from 'tripPlanner/hooks/reactQueryKeys/hotelSearch'
import { mapToDrawerHotels } from './mapToDrawerHotel'
import type { DrawerHotel } from './types'

const EMPTY_HOTELS: Array<DrawerHotel> = []

const HOTEL_SEARCH_STALE_TIME = 5 * 60 * 1000

interface UseHotelSearchOptions {
  searchQuery: string
  region?: string
  checkIn?: string
  checkOut?: string
  enabled: boolean
}

export default function useHotelSearch({
  searchQuery,
  region,
  checkIn,
  checkOut,
  enabled,
}: UseHotelSearchOptions) {
  const queryResult = useQuery({
    queryKey: HotelSearchKeys.search(searchQuery, region, checkIn, checkOut),
    queryFn: () => searchHotels({ query: searchQuery, region, checkIn, checkOut }),
    enabled: enabled && !!searchQuery,
    select: mapToDrawerHotels,
    staleTime: HOTEL_SEARCH_STALE_TIME,
  })

  return {
    hotels: queryResult.data ?? EMPTY_HOTELS,
    isLoading: queryResult.isLoading && queryResult.fetchStatus !== 'idle',
    isError: queryResult.isError,
  }
}
